<template>
  <component
    v-bind="$attrs"
    :is="params.style"
    :authors="items"
    :status="status"
    v-if="status == 'success'"
  ></component>
  <TrendingAuthorsAnimation v-else :animationStyle="params.style" />
  <div v-if="!items.length && status == 'success'">
    Sorry, we could not find any authors
  </div>
</template>

<script>
import API from "@/api";
import Util from "@/lib/Util";
import { computed } from "vue";
import OrbitQuery from "@/lib/OrbitQuery";
import TrendingAuthorsGrid from "@/templates/TrendingAuthorsGrid.vue";
import TrendingAuthorsList from "@/templates/TrendingAuthorsList.vue";
import TrendingAuthorsAnimation from "@/components/animation/TrendingAuthorsAnimation.vue";

export default {
  name: "TrendingAuthors",
  props: {
    params: Object,
  },
  components: {
    TrendingAuthorsGrid,
    TrendingAuthorsList,
    TrendingAuthorsAnimation,
  },
  setup(props) {
    const params = computed(() => {
      var params = Util.removeEmptyParams(
        JSON.parse(JSON.stringify(props.params))
      );
      params.trending = 1;

      return params;
    });

    const requestAPI = (params) => API.requestUsers(params);

    const { items, status } = OrbitQuery(params.value, requestAPI);

    return {
      items,
      status,
    };
  },
};
</script>
